// extracted by mini-css-extract-plugin
module.exports = {"brandsTitle":"brandsTitle-3k_WSeLw","titleWrapper":"titleWrapper-3evpufJl","title_logo":"title_logo-R9IIAM_4","title":"title-3oegBjkV","linkList":"linkList-SK8KsQmt"};